import { Translation } from './translation';
import { Translations } from '../constants/translations';
import { Block } from './block';
import { Blocks } from '../constants/blocks';

export const Contacts = () => {
  return (
    <section id="contacts" className="textSection">
      <div className="container container_narrow">
        <div className="textSection__header">
          <h2 className="h1">
            <Translation k={Translations.contacts} />
          </h2>
        </div>

        <div className="contentCard">
          <div className="text">
            <Block k={Blocks.contacts} />
          </div>
        </div>
      </div>
    </section>
  );
};
